import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344fb195"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "orienteme-steps" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registerSteps, (step, idx) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          key: idx,
          class: _normalizeClass(["orienteme-steps__item", 
               { '-last': _ctx.registerSteps.length === (idx + 1),
               '--active': step.id === _ctx.currentStep.id,
               'finished': step.finished }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: "#",
              onClick: ($event: any) => (_ctx.redirect(step))
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(step.id) + ".", 1),
              _createElementVNode("span", null, _toDisplayString(`${step.meta.title}`), 1),
              _withDirectives(_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_check)
                ]),
                _: 2
              }, 1536), [
                [_vShow, step.finished]
              ])
            ], 8, _hoisted_1),
            _createVNode(_component_el_divider, { style: {"margin-top":"10px","height":"4px"} })
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    _: 1
  }))
}